export default __webpack_public_path__ + "static/media/f358a55b-d1b1-4378-9253-6afdccadf482.26198e88.jpeg";